import { arvoresProximas, tiposManejo } from "@/mocks/coletor";

interface MobileTreeSummaryProps {
  treeId: string;
  onClose: () => void;
}

export default function MobileTreeSummary({ treeId, onClose }: MobileTreeSummaryProps) {
  const arvore = arvoresProximas.find((a) => a.id === treeId) || arvoresProximas[2];

  const riscoColor = arvore.risco === "Crítico" ? "text-[#D32F2F] bg-[#FFEBEE] border-[#D32F2F]"
    : arvore.risco === "Alto" ? "text-[#F57C00] bg-[#FFF3E0] border-[#F57C00]"
    : arvore.risco === "Médio" ? "text-[#FBC02D] bg-[#FFFDE7] border-[#FBC02D]"
    : "text-[#1B6E4F] bg-[#CAF0D3] border-[#1B6E4F]";

  const fitColor = arvore.fitossanitario === "Bom" ? "text-[#1B6E4F] bg-[#CAF0D3]"
    : arvore.fitossanitario === "Regular" ? "text-[#FBC02D] bg-[#FFFDE7]"
    : arvore.fitossanitario === "Ruim" ? "text-[#F57C00] bg-[#FFF3E0]"
    : "text-[#D32F2F] bg-[#FFEBEE]";

  return (
    <div className="px-4 pt-4 pb-20 max-w-lg mx-auto">
      <div className="flex items-center gap-2 mb-4">
        <button onClick={onClose} className="w-8 h-8 rounded-lg hover:bg-[#E8EAED] flex items-center justify-center">
          <i className="ri-arrow-left-line text-[#3F4A52] text-lg" />
        </button>
        <h2 className="text-lg font-heading font-bold text-[#3F4A52]">FCA Resumida</h2>
      </div>

      {/* Foto */}
      <div className="rounded-xl overflow-hidden border border-[#E8EAED] h-56 bg-[#E8EAED] mb-4">
        <img src={arvore.foto} alt={arvore.especie} className="w-full h-full object-cover" />
      </div>

      {/* Header info */}
      <div className="mb-4">
        <h3 className="text-xl font-heading font-bold text-[#3F4A52]">{arvore.especie}</h3>
        <p className="text-xs text-[#3F4A52]/50 italic mt-0.5">{arvore.cientifico}</p>
        <p className="text-xs font-mono text-[#0052CC] mt-1">{arvore.id}</p>
      </div>

      {/* Badges */}
      <div className="flex gap-2 mb-4">
        <span className={`px-3 py-1 rounded-full text-xs font-medium border ${riscoColor}`}>
          <i className="ri-alert-line mr-0.5" /> Risco {arvore.risco}
        </span>
        <span className={`px-3 py-1 rounded-full text-xs font-medium ${fitColor}`}>
          <i className="ri-heart-pulse-line mr-0.5" /> {arvore.fitossanitario}
        </span>
      </div>

      {/* Info grid */}
      <div className="bg-white border border-[#E8EAED] rounded-xl divide-y divide-[#E8EAED] mb-4">
        {[
          ["Bairro", arvore.bairro],
          ["Coordenadas", `${arvore.latitude}, ${arvore.longitude}`],
          ["Última vistoria", "15/06/2026"],
          ["Manejo recomendado", "Poda de limpeza + Monitorar"],
        ].map(([label, value], i) => (
          <div key={i} className="flex items-center justify-between px-4 py-3">
            <span className="text-xs text-[#3F4A52]/60">{label}</span>
            <span className="text-xs font-medium text-[#3F4A52]">{value}</span>
          </div>
        ))}
      </div>

      {/* Ações */}
      <div className="grid grid-cols-2 gap-2 mb-2">
        <button className="py-3.5 rounded-xl bg-[#0052CC] text-white font-heading font-bold text-sm flex items-center justify-center gap-1.5">
          <i className="ri-clipboard-line" /> Nova vistoria
        </button>
        <button className="py-3.5 rounded-xl bg-[#1B6E4F] text-white font-heading font-bold text-sm flex items-center justify-center gap-1.5">
          <i className="ri-camera-line" /> Adicionar foto
        </button>
      </div>
      <div className="grid grid-cols-2 gap-2">
        <button className="py-3 rounded-xl border border-[#E8EAED] text-sm font-medium text-[#3F4A52] flex items-center justify-center gap-1.5">
          <i className="ri-map-pin-line" /> Abrir no mapa
        </button>
        <button className="py-3 rounded-xl border border-[#E8EAED] text-sm font-medium text-[#3F4A52] flex items-center justify-center gap-1.5">
          <i className="ri-history-line" /> Ver histórico
        </button>
      </div>
    </div>
  );
}